import React from "react";
import "./Menu.scss";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Menu = ({
  projects = [],
  categories = [],
  setSlider,
  informations = [],
  setShowInfoGlobal,
  setActiveInfoIds,
  activeInfoIds = [],
  setIsInfoExpanded,
  showInfo,
  setShowInfo,
  showTypes,
  setShowTypes,
  selectedType,
  setSelectedType,
}) => {
  const { language, prevLanguage, isFading } = useLanguage();
  const navigate = useNavigate();

  const handleProjectClick = () => {
    setShowTypes(!showTypes);
    if (!showTypes) {
      if (setShowInfo) setShowInfo(false);
      if (setIsInfoExpanded) setIsInfoExpanded(false);
      if (setShowInfoGlobal) setShowInfoGlobal(false);
      if (setActiveInfoIds) setActiveInfoIds([]);
    }
    if (showTypes) setSelectedType(null);
  };

  const handleInfoClick = () => {
    const newState = !showInfo;
    if (setShowInfo) setShowInfo(newState);
    if (newState) {
      setShowTypes(false);
      setSelectedType(null);
      navigate("/info");
    }
    if (setShowInfoGlobal) setShowInfoGlobal(newState);
    if (!newState && setActiveInfoIds) {
      setActiveInfoIds([]);
      if (setIsInfoExpanded) setIsInfoExpanded(false);
    }
  };

  const handleInfoItemClick = (id) => {
    if (setActiveInfoIds) {
      setActiveInfoIds((prev) => {
        const isCurrentlyActive = prev.includes(id);
        let nextActiveIds;

        if (window.innerWidth <= 768) {
          nextActiveIds = isCurrentlyActive ? [] : [id];
        } else {
          nextActiveIds = isCurrentlyActive
            ? prev.filter((itemId) => itemId !== id)
            : [...prev, id];
        }

        if (setIsInfoExpanded) {
          setIsInfoExpanded(nextActiveIds.length > 0);
        }

        return nextActiveIds;
      });
    }
  };

  const handleTypeClick = (type) => {
    setSelectedType(selectedType === type ? null : type);
  };

  const isBioOpen = activeInfoIds.includes("4TlvwSJZOp8hFEg7UArlM2");

  return (
    <div
      className={`menu ${isBioOpen ? "bio-open" : ""} ${isFading ? "is-fading" : ""}`}
    >
      <div className="menu-projects">
        <p onClick={handleProjectClick} className="menu-trigger">
          <span className="lang-current">
            {language === "fr" ? "Réalisations" : "Creations"}
          </span>
          {isFading && (
            <span className="lang-prev">
              {prevLanguage === "fr" ? "Réalisations" : "Creations"}
            </span>
          )}
        </p>

        {showTypes && (
          <div className="menu-projects-types">
            {[...categories]
              .sort((a, b) => (a.fields?.ordre || 0) - (b.fields?.ordre || 0))
              .map((cat, idx) => (
                <div key={`cat-${idx}`} className="type-group">
                  <Link
                    to={`/${cat.fields?.url}`}
                    className="type-item"
                    onClick={() => {
                      if (setActiveInfoIds) setActiveInfoIds([]);
                      if (setShowInfoGlobal) setShowInfoGlobal(false);
                      if (setIsInfoExpanded) setIsInfoExpanded(false);
                      if (setShowInfo) setShowInfo(false);
                    }}
                  >
                    {cat.fields?.titre}
                  </Link>
                </div>
              ))}

            {/* Hardcoded "In situ" category since it aggregates all top-level projects, or if it has projects let's display them */}
            {projects.length > 0 && (
              <div className="type-group">
                <p
                  className="type-item"
                  onClick={() => handleTypeClick("in-situ")}
                >
                  <span className="lang-current">
                    {language === "fr" ? "In situ" : "In situ"}
                  </span>
                  {isFading && (
                    <span className="lang-prev">
                      {prevLanguage === "fr" ? "In situ" : "In situ"}
                    </span>
                  )}
                </p>
                {selectedType === "in-situ" && (
                  <div className="type-projects">
                    {[...projects]
                      .sort((a, b) => (a.fields?.ordre || 0) - (b.fields?.ordre || 0))
                      .map((p, pIdx) => (
                      <Link
                        key={`proj-${pIdx}`}
                        to={`/${p.fields?.url}`}
                        className="project-title-item"
                        onClick={() => {
                          if (setActiveInfoIds) setActiveInfoIds([]);
                          if (setShowInfoGlobal) setShowInfoGlobal(false);
                          if (setIsInfoExpanded) setIsInfoExpanded(false);
                          setShowInfo(false);
                        }}
                      >
                        {p.fields?.titre}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="menu-info">
        <p onClick={handleInfoClick} className="menu-trigger">
          <span className="lang-current">
            {language === "fr" ? "Informations" : "Information"}
          </span>
          {isFading && (
            <span className="lang-prev">
              {prevLanguage === "fr" ? "Informations" : "Information"}
            </span>
          )}
        </p>
        {showInfo && (
          <div className="menu-info-types">
            {[...informations]
              .sort((a, b) => (a.fields?.ordre || 0) - (b.fields?.ordre || 0))
              .filter((info) => info.fields?.titre !== "Crédits")
              .map((info, idx) => {
                const isActive = activeInfoIds.includes(info.sys?.id);
                const pdfUrl = info.fields?.pdf?.fields?.file?.url;
                if (pdfUrl) {
                  const fullUrl = pdfUrl.startsWith("http")
                    ? pdfUrl
                    : `https:${pdfUrl}`;
                  return (
                    <a
                      key={idx}
                      className="info-item"
                      href={fullUrl}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {info.fields?.titre}
                    </a>
                  );
                }
                return (
                  <p
                    key={idx}
                    className={`info-item ${isActive ? "active" : ""}`}
                    onClick={() => handleInfoItemClick(info.sys?.id)}
                  >
                    {info.fields?.titre}
                  </p>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Menu;
